import React from 'react'
import { useTranslation } from 'react-i18next'

import { ResidentAppIllustration } from '../../components/ResidentAppIllustration'
import Success from '../../components/Success'

export const FeedbackSuccess: React.FC = () => {
  const { t } = useTranslation(['common', 'feedback'])

  return (
    <Success
      illustration={
        <ResidentAppIllustration
          name="house-hearth-eyes"
          alt={t('feedback:alt.successIllustration')}
          className="-ml-2"
        />
      }
      heading={t('common:thankYou')}
      text={t('feedback:texts.success')}
    />
  )
}
